export default {
  computed: {
    profileLegalDocuments() {
      return [
        {
          documentName: 'termsConditions',
          text: this.$t('termsAndConditions.title'),
          icon: '$fileUploaded',
          textColor: 'black',
          click: () => {
            this.$router.push(
              this.$localePath({
                name: this.currentPath,
                query: {
                  ...this.$route.query,
                  stepProfile: 3,
                  type: 'document',
                  documentName: 'termsConditions'
                }
              })
            );
          },
          category: 'default',
          typeName: 'terms_and_conditions'
        },
        {
          documentName: 'privacyPolicy',
          text: this.$t('personalDataProcessing.title'),
          icon: '$fileUploaded',
          textColor: 'black',
          click: () => {
            this.$router.push(
              this.$localePath({
                name: this.currentPath,
                query: {
                  ...this.$route.query,
                  stepProfile: 3,
                  type: 'document',
                  documentName: 'privacyPolicy'
                }
              })
            );
          },
          category: 'default',
          typeName: 'personal_data_processing'
        },
        {
          documentName: 'newsletterAgreement',
          text: this.$t('newsletter.title'),
          icon: '$fileUploaded',
          textColor: 'black',
          click: () => {
            this.$router.push(
              this.$localePath({
                name: this.currentPath,
                query: {
                  ...this.$route.query,
                  stepProfile: 3,
                  type: 'document',
                  documentName: 'newsletterAgreement'
                }
              })
            );
          },
          category: 'default',
          typeName: 'newsletter'
        }
      ];
    }
  }
};
